import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/underwriters`;
const baseAccountRoute = `${url}/account`;

export const getAllUnderwriterUsers = async () => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getUnderwriterUserById = async id => {
  const url = `${baseRoute}/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getUnderwriterOptions = async (options = {}) => {
  const q = queryString.stringify(options);
  const url = `${baseRoute}/options?${q}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const createUnderwriterUser = async user => {
  user.role = 'UNDERWRITER';
  const url = `${baseAccountRoute}/RegisterUser`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const putUnderwriterUser = async user => {
  user.role = 'UNDERWRITER';
  const url = `${baseAccountRoute}/UpdateUser`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(user),
  });
  return response;
};
